import { useState } from "react";

import { getYear, getMonth } from "./MonthPicker.helpers";

import MonthPicker from "./MonthPicker";

const MonthPickerContainer = ({ date, className, onChange }: any) => {
  const [selectedYear, setSelectedYear] = useState(getYear(date));

  const [year, setYear] = useState(getYear(date));
  const [month, setMonth] = useState(getMonth(date));

  const handlePreviousYearClick = () => {
    setYear(Number(year) - 1);
  };

  const handleNextYearClick = () => {
    setYear(Number(year) + 1);
  };

  const handleMonthClick = (month: string) => {
    setMonth(month);
    setSelectedYear(year);

    if (onChange) {
      onChange(`${year}-${month}-01`);
    }
  };

  return (
    <MonthPicker
      className={className}
      year={year}
      selectedYear={selectedYear}
      month={month}
      onPreviousYearClick={handlePreviousYearClick}
      onNextYearClick={handleNextYearClick}
      onMonthClick={handleMonthClick}
    />
  );
};

export default MonthPickerContainer;
